import styled from "styled-components";
import { devices } from "../../../Devices";

export const Container = styled.div`
  padding: 2rem 3.6rem;
  min-height: 100vh;
  background: #fff;
  @media ${devices.mobileL} {
    padding: 1rem 0.5rem;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: start;
`;

export const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 600;
  margin: 2.5rem 0 1.5rem 0;
  text-align: center;
  color: #22223b;
  @media ${devices.mobileL} {
    font-size: 1.6rem;
    margin: 1.5rem 0 1rem 0;
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  margin-top: 2rem;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  font-size: 1.2rem;
  @media ${devices.mobileL} {
    font-size: 1rem;
    min-width: 480px;
  }
  th,
  td {
    padding: 0.8rem 1rem;
    text-align: left;
    border-bottom: 1px solid #eaeaea;
  }
  th {
    background: #fbf1e6;
    color: #22223b;
    font-weight: 600;
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
  gap: 1rem;
`;

export const PageButton = styled.button`
  background: #fbf1e6;
  color: #22223b;
  border: none;
  border-radius: 0.5rem;
  padding: 0.5rem 1.2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #fbbf24;
  }
  &:disabled {
    background: #eaeaea;
    color: #aaa;
    cursor: not-allowed;
  }
`;

export const SearchInput = styled.input`
  padding: 0.6rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #eaeaea;
  font-size: 1.1rem;
  width: 100%;
  max-width: 350px;
`;

export const ClearButton = styled.button`
  background: #eaeaea;
  color: #22223b;
  border: none;
  border-radius: 0.5rem;
  padding: 0.6rem 1.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  margin-left: 0.5rem;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #ffdddd;
  }
`;

export const SearchButton = styled.button`
  background: #fbbf24;
  color: #22223b;
  border: none;
  border-radius: 0.5rem;
  padding: 0.6rem 1.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  margin-left: 0.5rem;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #fbf1e6;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.06);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  // box-shadow: 0 20px 20px 5px rgba(1, 1, 1, 0.1);
  max-width: 900px;
  width: 95vw;
  max-height: 95vh;
  overflow: auto;
`;
